import { admin } from './admin.js';
import { cart } from './cart.js';
import { catalog } from './catalog.js';
import { common } from './common.js';
import { header } from './header.js';
import { home } from './home.js';
import { product } from './product.js';
export const ptBR = {
    admin,
    common,
    catalog,
    cart,
    header,
    home,
    product,
};
//# sourceMappingURL=index.js.map